import { Component, Element, Event, EventEmitter, h, Host, Prop, State, Watch } from "@stencil/core";

@Component({
    tag: "ux-onboarding-guide",
    styleUrl: "./onboarding-guide.scss",
    shadow: true
})
export class OnboardingGuide {
    @Element() el: HTMLUxOnboardingGuideElement;
    /** Current step index  */
    @Prop() readonly current: number = 0;

    @State() internalCurrent = 0;

    /** Reference to the default slot element inside .content-container */
    private slotEl: HTMLSlotElement;

    @Watch("current")
    watchCurrent(value: number) {
        this.internalCurrent = value;
    }

    /** Event for change of step index */
    @Event({
        eventName: "uxOnboardingGuideChange",
        composed: false,
        cancelable: false,
        bubbles: true
    })
    onboardingGuideChange: EventEmitter<{ closed: boolean; stepIndex: number }>;

    /** Array of slotted elements (steps) */
    @State() steps: Element[] = [];

    componentWillLoad() {
        this.watchCurrent(this.current);
    }

    componentDidRender() {
        if (this.slotEl) {
            const children = this.slotEl.assignedElements({ flatten: true });

            if (children.length !== this.steps.length) {
                this.steps = children;
            }

            children.forEach((child, index) => {
                (child as HTMLElement).style.display = index === this.internalCurrent ? "block" : "none";
            });
        }
    }

    private onModalClose = () => {
        this.onboardingGuideChange.emit({ closed: true, stepIndex: this.internalCurrent });
    };

    private goToNextStep = () => {
        if (this.internalCurrent < this.steps.length - 1) {
            this.internalCurrent++;
            this.onboardingGuideChange.emit({ closed: false, stepIndex: this.internalCurrent });
        }
    };

    private goToPreviousStep = () => {
        if (this.internalCurrent > 0) {
            this.internalCurrent--;
            this.onboardingGuideChange.emit({ closed: false, stepIndex: this.internalCurrent });
        }
    };

    render() {
        return (
            <Host>
                <ux-modal opened name="ux-onboarding-guide-modal" onUxModalClose={this.onModalClose}>
                    <ux-modal-content>
                        <div class="container">
                            {this.internalCurrent === null ? (
                                <slot name="spinner"></slot>
                            ) : (
                                <div>
                                    <ux-progress-bar current={this.internalCurrent + 1} steps={this.steps.length} />
                                    <div class="content-container">
                                        <slot ref={(el) => (this.slotEl = el as HTMLSlotElement)}></slot>
                                    </div>
                                    <slot name={`navigation-${this.internalCurrent}`}>
                                        <div class="navigation">
                                            <ux-button onClick={this.goToPreviousStep}>
                                                <slot name="button-left" />
                                            </ux-button>
                                            <ux-button onClick={this.goToNextStep}>
                                                <slot name="button-right" />
                                            </ux-button>
                                        </div>
                                    </slot>
                                </div>
                            )}
                        </div>
                    </ux-modal-content>
                </ux-modal>
            </Host>
        );
    }
}
